import React, { createContext, useCallback, useMemo, useState } from 'react'

type ContextState = {
  isAnyDirty: boolean
  setIsDirty: (id: string, isDirty: boolean) => void
}

export const DirtyContext = createContext<ContextState>({
  isAnyDirty: false,
  setIsDirty: () => {}
})

export function DirtyProvider({ children }: React.PropsWithChildren) {
  const [dirtyIds, setDirtyIds] = useState<Set<string>>(new Set())
  const isAnyDirty = dirtyIds.size > 0

  const setIsDirty = useCallback(
    (id: string, isDirty: boolean) => {
      setDirtyIds(set => {
        const newSet = new Set(set)

        if (isDirty) newSet.add(id)
        else newSet.delete(id)

        return newSet
      })
    },
    [setDirtyIds]
  )

  const value = useMemo(() => {
    return {
      isAnyDirty,
      setIsDirty
    }
  }, [isAnyDirty, setIsDirty])

  return <DirtyContext value={value}>{children}</DirtyContext>
}
